module.exports = __webpack_public_path__ + "img/video_play.b0a95567.svg";